import * as _ from "lodash";
import * as async from "async";
import * as bootstrap from "bootstrap";
import * as angular from "angular";
import classTerritoire from "./classTerritoire";
import classBailleur from "./classBailleur";
import * as google from "angular-google-chart";
import * as $ from "jquery";
import { saveAs } from "file-saver";

let App = angular.module("App", ["googlechart"]);
import "./directives/templateRow";
import "./directives/componentDirective";

App.controller("TerritoiresController", [
    "$scope",
    "$http",
    "$timeout",
    "$rootScope",
    "$location",
    function ($scope, $http, $timeout, $rootScope, $location) {
        angular.element(document).ready(function () {
            $scope.initialisation = function () {
                $scope.listeRegion = [];
                $scope.listeRegionBailleur = [];
                $scope.listeDepartement = [];
                $scope.listeDepartementBailleur = [];
                $scope.listeEpci = [];
                $scope.listeEpciBailleur = [];
                $scope.listeCommune = [];
                $scope.listeCommuneBailleur = [];
                $scope.listeResidences = [];

                $scope.listeRegionDisplay = [];
                $scope.listeDepartementDisplay = [];
                $scope.listeEpciDisplay = [];
                $scope.listeCommuneDisplay = [];

                $scope.titleTerritoire = "";
                $scope.titleBailleur = "";
                $scope.titleResidence = "";
                $scope.showGraph = true;
                $scope.year = null;

                $scope.IDusers = angular.element("#IDusers").val();
                getDatasDropdown();
            };
            $scope.checkShowGraph = function () {
                $scope.showGraph = !$scope.showGraph;
            };

            //FUNCTIONS
            function getDatasDropdown() {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const year = urlParams.get("year");
                $http({
                    url: "/ajax/locations",
                    method: "GET",
                    params: { year },
                }).then(function (response) {
                    let data = response.data;
                    if (data === "redirect") {
                        window.location.href = "/";
                    }

                    let bailleurLocations = _.filter(data, {
                        bailleur: true,
                    });

                    //departements
                    $scope.listeRegion = _.map(data, function (o: any) {
                        return {
                            region: o.region,
                        };
                    });
                    $scope.listeRegion = _.uniqBy($scope.listeRegion, "region");
                    _.forEach($scope.listeRegion, function (o: any) {
                        if (
                            _.find(bailleurLocations, function (i: any) {
                                return i.region == o.region;
                            })
                        ) {
                            o.bailleur = true;
                            $scope.listeRegionBailleur.push(o);
                        } else {
                            o.bailleur = false;
                        }
                    });
                    $scope.listeDepartement = _.map(data, function (o: any) {
                        return {
                            departement: o.departement,
                            region: o.region,
                            uniqKey: o.region + "|" + o.departement + "-|-",
                        };
                    });
                    $scope.listeDepartement = _.uniqBy(
                        $scope.listeDepartement,
                        "departement"
                    );
                    _.forEach($scope.listeDepartement, function (o: any) {
                        if (
                            _.find(bailleurLocations, function (i: any) {
                                return i.departement == o.departement;
                            })
                        ) {
                            o.bailleur = true;
                            $scope.listeDepartementBailleur.push(o);
                        } else {
                            o.bailleur = false;
                        }
                    });
                    //epci
                    $scope.listeEpci = _.map(data, function (o: any) {
                        return {
                            epci: o.epci,
                            departement: o.departement,
                            region: o.region,
                            uniqKey:
                                o.region +
                                "|" +
                                o.departement +
                                "|" +
                                o.epci +
                                "|-",
                        };
                    });
                    $scope.listeEpci = _.uniqBy(
                        $scope.listeEpci,
                        function (v: any) {
                            return JSON.stringify([v.epci, v.departement]);
                        }
                    );
                    _.forEach($scope.listeEpci, function (o: any) {
                        if (
                            _.find(bailleurLocations, function (i: any) {
                                return i.epci == o.epci;
                            })
                        ) {
                            o.bailleur = true;
                            $scope.listeEpciBailleur.push(o);
                        } else {
                            o.bailleur = false;
                        }
                    });
                    //communes
                    $scope.listeCommune = data;
                    _.forEach($scope.listeCommune, function (o: any) {
                        if (
                            _.find(bailleurLocations, function (i: any) {
                                return i.commune == o.commune;
                            })
                        ) {
                            o.bailleur = true;
                            $scope.listeCommuneBailleur.push(o);
                        } else {
                            o.bailleur = false;
                        }
                        o.uniqKey =
                            o.region +
                            "|" +
                            o.departement +
                            "|" +
                            o.epci +
                            "|" +
                            o.commune;
                    });
                    RAZinputs();
                    refreshDOM();
                });
            }
            function getFicheTerritoire() {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const year = urlParams.get("year");
                let custom_key = "";
                if ($scope.selectedRegion) {
                    custom_key += $scope.selectedRegion + "|";
                    if ($scope.selectedDepartement) {
                        custom_key += $scope.selectedDepartement + "|";
                    } else {
                        custom_key += "-|";
                    }
                    if ($scope.selectedEpci) {
                        custom_key +=
                            uniqKeyToData($scope.selectedEpci).epci + "|";
                    } else {
                        custom_key += "-|";
                    }
                    if ($scope.selectedCommune) {
                        custom_key += $scope.selectedCommune;
                    } else {
                        custom_key += "-";
                    }
                }
                $http({
                    url: "ajax/territoire/ficheTerritoire",
                    method: "POST",
                    responseType: "blob",

                    params: {
                        year,
                        localisation_bailleur: $scope.selectedOrganisation,
                        IDusers: $scope.IDusers,
                        custom_key: custom_key,
                    },
                }).then((data) => {
                    let file = new Blob([data.data], {
                        type:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    saveAs(
                        file,
                        data.config.params.localisation_bailleur + ".docx",
                        { "Content-Transfer-Encoding": "binary" }
                    );
                });
            }
            function setListeRegionDisplay() {
                if ($scope.selectedFilter) {
                    $scope.listeRegionDisplay = _.clone(
                        $scope.listeRegionBailleur
                    );
                } else {
                    $scope.listeRegionDisplay = _.clone($scope.listeRegion);
                }
            }

            function setListeDepartementDisplay(arrayRegions) {
                $scope.listeDepartementDisplay = [];
                _.forEach(arrayRegions, function (o1: any) {
                    let listeDepartementTmp;
                    if ($scope.selectedFilter) {
                        listeDepartementTmp = _.filter(
                            $scope.listeDepartementBailleur,
                            function (o: any) {
                                return o1 == o.region;
                            }
                        );
                    } else {
                        listeDepartementTmp = _.filter(
                            $scope.listeDepartement,
                            function (o: any) {
                                return o1 == o.region;
                            }
                        );
                    }
                    $scope.listeDepartementDisplay.push({
                        region: o1,
                        listeDepartement: listeDepartementTmp,
                    });
                });
            }

            function setListeEpciDisplay(arrayDepartements) {
                $scope.listeEpciDisplay = [];
                _.forEach(arrayDepartements, function (o1: any) {
                    let listeEpciTmp;
                    if ($scope.selectedFilter) {
                        listeEpciTmp = _.filter(
                            $scope.listeEpciBailleur,
                            function (o: any) {
                                return o1 == o.departement;
                            }
                        );
                    } else {
                        listeEpciTmp = _.filter(
                            $scope.listeEpci,
                            function (o: any) {
                                return o1 == o.departement;
                            }
                        );
                    }
                    $scope.listeEpciDisplay.push({
                        departement: o1,
                        listeEpci: listeEpciTmp,
                    });
                });
            }

            function setListeCommuneDisplay(arrayEpci) {
                $scope.listeCommuneDisplay = [];
                _.forEach(arrayEpci, function (o1) {
                    let listeCommuneTmp;
                    if ($scope.selectedFilter) {
                        listeCommuneTmp = _.filter(
                            $scope.listeCommuneBailleur,
                            function (o: any) {
                                return o1 == o.epci;
                            }
                        );
                    } else {
                        listeCommuneTmp = _.filter(
                            $scope.listeCommune,
                            function (o: any) {
                                return o1 == o.epci;
                            }
                        );
                    }
                    $scope.listeCommuneDisplay.push({
                        epci: o1,
                        listeCommune: listeCommuneTmp,
                    });
                });
            }

            function RAZinputs() {
                if (!_.isNil($scope.listeRegion)) setListeRegionDisplay();
                if (!_.isNil($scope.listeDepartement))
                    setListeDepartementDisplay(
                        _.map($scope.listeRegion, "region")
                    );
                if (!_.isNil($scope.listeDepartement))
                    setListeEpciDisplay(
                        _.map($scope.listeDepartement, "departement")
                    );
                if (!_.isNil($scope.listeEpci))
                    setListeCommuneDisplay(_.map($scope.listeEpci, "epci"));

                $scope.selectedRegion = null;
                $scope.selectedDepartement = null;
                $scope.selectedEpci = null;
                $scope.selectedCommune = null;
                $scope.dataTerritoire = null;
                $scope.year = null;
                $scope.dataBailleur = null;
            }

            function refreshDOM() {
                $timeout(function () {
                    (<any>angular.element(".selectpicker")).selectpicker(
                        "refresh"
                    );

                    if (!_.isNil($scope.selectedRegion)) {
                        (<any>angular.element("#selectRegion")).selectpicker(
                            "val",
                            $scope.selectedRegion
                        );
                    }
                    if (!_.isNil($scope.selectedDepartement)) {
                        (<any>(
                            angular.element("#selectDepartements")
                        )).selectpicker("val", $scope.selectedDepartement);
                    }
                    if (!_.isNil($scope.selectedEpci)) {
                        (<any>angular.element("#selectEPCI")).selectpicker(
                            "val",
                            $scope.selectedEpci
                        );
                    }
                    if (!_.isNil($scope.selectedCommune)) {
                        (<any>angular.element("#selectCommunes")).selectpicker(
                            "val",
                            $scope.selectedCommune
                        );
                    }
                });
                let custom_id = "";
                if ($scope.selectedRegion) {
                    custom_id += $scope.selectedRegion + "|";
                    if ($scope.selectedDepartement) {
                        custom_id += $scope.selectedDepartement + "|";
                    } else {
                        custom_id += "-|";
                    }
                    if ($scope.selectedEpci) {
                        custom_id +=
                            uniqKeyToData($scope.selectedEpci).epci + "|";
                    } else {
                        custom_id += "-|";
                    }
                    if ($scope.selectedCommune) {
                        custom_id += $scope.selectedCommune;
                    } else {
                        custom_id += "-";
                    }

                    getDatasTerritoire(custom_id);
                }
            }

            function setRegion() {
                if ($scope.selectedRegion) {
                    setListeDepartementDisplay([$scope.selectedRegion]);
                    let arrayDpt = _.map(
                        _.filter($scope.listeDepartement, function (o: any) {
                            return o.region == $scope.selectedRegion;
                        }),
                        "departement"
                    );
                    setListeEpciDisplay(arrayDpt);
                    setListeCommuneDisplay($scope.listeEpciDisplay);
                } else {
                    setListeDepartementDisplay(
                        _.map($scope.listeRegion, "region")
                    );
                    setListeEpciDisplay(
                        _.map($scope.listeDepartement, "departement")
                    );
                    setListeCommuneDisplay(_.map($scope.listeEpci, "epci"));
                }
                $scope.selectedDepartement = null;
                $scope.selectedEpci = null;
                $scope.selectedCommune = null;
            }

            function setDepartement() {
                // Sous filtre sur les EPCI et Communes à afficher
                if ($scope.selectedDepartement) {
                    let tmp = _.find(
                        $scope.listeDepartement,
                        function (o: any) {
                            return o.departement == $scope.selectedDepartement;
                        }
                    );
                    $scope.selectedRegion = tmp?.region;
                    setListeEpciDisplay([$scope.selectedDepartement]);
                    let arrayEpci = _.map(
                        _.filter($scope.listeEpci, function (o: any) {
                            return o.departement == $scope.selectedDepartement;
                        }),
                        "epci"
                    );
                    _.uniqBy(arrayEpci, "epci");
                    setListeCommuneDisplay(arrayEpci);
                } else {
                    setListeEpciDisplay(
                        _.map($scope.listeDepartement, "departement")
                    );
                    setListeCommuneDisplay(_.map($scope.listeEpci, "epci"));
                }

                // Mise à blanc des autres champs EPCI et Communes
                $scope.selectedEpci = null;
                $scope.selectedCommune = null;
            }

            function setEpci() {
                //selection de la epci et département
                if ($scope.selectedEpci) {
                    let tmp = _.find($scope.listeEpci, function (o: any) {
                        return o.uniqKey == $scope.selectedEpci;
                    });
                    // $scope.selectedEpci = epci.epci;
                    $scope.selectedRegion = tmp?.region;
                    $scope.selectedDepartement = tmp.departement;

                    // Sous filtre sur les Communes à afficher
                    setListeCommuneDisplay([
                        uniqKeyToData($scope.selectedEpci).epci,
                    ]);
                } else {
                    setListeCommuneDisplay(_.map($scope.listeEpci, "epci"));
                }

                // Mise à blanc des autres champs  Communes
                $scope.selectedCommune = null;
            }

            function setCommune() {
                //selection de la commune, epci et département
                let tmp = _.find($scope.listeCommune, function (o: any) {
                    return o.commune == $scope.selectedCommune;
                });
                $scope.selectedRegion = tmp?.region;
                $scope.selectedDepartement = tmp.departement;
                $scope.selectedEpci = dataToUniqKey(tmp);
            }

            function fetchResidences() {
                $http({
                    url: "ajax/territoire/residences",
                    method: "POST",
                    params: {
                        localisation_bailleur: $scope.selectedOrganisation,
                        localisation_commune: $scope.selectedCommune
                    },
                })
                    .then(function (response) {
                        $timeout(function () {
                            $scope.listeResidences = response.data;
                            refreshDOM();
                        });
                    });
            }

            function uniqKeyToData(key) {
                let data = key.split("|");
                return {
                    région: data[0],
                    departement: data[1],
                    epci: data[2],
                    commune: data[3],
                };
            }

            function dataToUniqKey(data) {
                let uniqKey = "";
                if (data.region) {
                    uniqKey = data.region;
                } else {
                    uniqKey = "-";
                }
                if (data.departement) {
                    uniqKey += "|" + data.departement;
                } else {
                    uniqKey += "|-";
                }
                if (data.epci) {
                    uniqKey += "|" + data.epci + "|-";
                } else {
                    uniqKey += "|-|-";
                }

                return uniqKey;
            }

            function getDatasTerritoire(custom_key) {
                $scope.dataTerritoire = null;
                $scope.year = null;
                $scope.dataBailleur = null;
                let dataTerritoire: any;
                let year: any;
                let dataBailleur: any;
                let dataRegion: any;
                let dataDepartement: any;
                let dataEPCI: any;
                let dataCommune: any;
                let splitedKey = custom_key.split("|");

                let targetLevel = "commune";
                if (splitedKey[3] == "-") targetLevel = "EPCI";
                if (splitedKey[2] == "-") targetLevel = "departement";
                if (splitedKey[1] == "-") targetLevel = "region";

                async.parallel(
                    [
                        function (done) {
                            const queryString = window.location.search;
                            const urlParams = new URLSearchParams(queryString);
                            const year = urlParams.get("year");
                            $http({
                                url: "ajax/territoire",
                                method: "POST",
                                params: {
                                    year,
                                    custom_key: `${splitedKey[0]}|-|-|-`,
                                },
                            }).then(function (response) {
                                dataRegion = response.data;
                                if (targetLevel == "region") {
                                    $scope.year = year;
                                    dataTerritoire = response.data;
                                    $scope.titleTerritoire =
                                        "Région : " +
                                        dataTerritoire?.localisation.region;
                                }
                                done();
                            });
                        },
                        function (done) {
                            if (
                                targetLevel == "commune" ||
                                targetLevel == "EPCI" ||
                                targetLevel == "departement"
                            ) {
                                const queryString = window.location.search;
                                const urlParams = new URLSearchParams(
                                    queryString
                                );
                                const year = urlParams.get("year");
                                $http({
                                    url: "ajax/territoire",
                                    method: "POST",
                                    params: {
                                        year,
                                        custom_key: `${splitedKey[0]}|${splitedKey[1]}|-|-`,
                                    },
                                }).then(function (response) {
                                    dataDepartement = response.data;
                                    if (targetLevel == "departement") {
                                        $scope.year = year;
                                        dataTerritoire = response.data;
                                        $scope.titleTerritoire =
                                            "Département : " +
                                            dataTerritoire.localisation
                                                .departement;
                                    }
                                    done();
                                });
                            } else {
                                done();
                            }
                        },
                        function (done) {
                            if (
                                targetLevel == "commune" ||
                                targetLevel == "EPCI"
                            ) {
                                const queryString = window.location.search;
                                const urlParams = new URLSearchParams(
                                    queryString
                                );
                                const year = urlParams.get("year");
                                $http({
                                    url: "ajax/territoire",
                                    method: "POST",
                                    params: {
                                        year,
                                        custom_key: `${splitedKey[0]}|${splitedKey[1]}|${splitedKey[2]}|-`,
                                    },
                                }).then(function (response) {
                                    dataEPCI = response.data;
                                    if (targetLevel == "EPCI") {
                                        $scope.year = year;

                                        dataTerritoire = response.data;
                                        $scope.titleTerritoire =
                                            "EPCI : " +
                                            dataTerritoire.localisation.EPCI;
                                    }
                                    done();
                                });
                            } else {
                                done();
                            }
                        },
                        function (done) {
                            if (targetLevel == "commune") {
                                const queryString = window.location.search;
                                const urlParams = new URLSearchParams(
                                    queryString
                                );
                                const year = urlParams.get("year");
                                $http({
                                    url: "ajax/territoire",
                                    method: "POST",
                                    params: {
                                        year,
                                        custom_key: custom_key,
                                    },
                                }).then(function (response) {
                                    dataCommune = response.data;
                                    if (targetLevel == "commune") {
                                        $scope.year = year;

                                        dataTerritoire = response.data;
                                        $scope.titleTerritoire =
                                            "Commune : " +
                                            dataTerritoire.localisation.commune;
                                    }
                                    done();
                                });
                            } else {
                                done();
                            }
                        },
                        function (done) {
                            if (!_.isNil($scope.selectedOrganisation)) {
                                const queryString = window.location.search;
                                const urlParams = new URLSearchParams(
                                    queryString
                                );
                                const year = urlParams.get("year");
                                $http({
                                    url: "ajax/territoire/bailleur",
                                    method: "POST",
                                    params: {
                                        year,
                                        localisation_bailleur:
                                            $scope.selectedOrganisation,
                                        residences:
                                            JSON.stringify($scope.selectedResidence),
                                        IDusers: $scope.IDusers,
                                        custom_key: custom_key,
                                    },
                                }).then(
                                    function (response) {
                                        if (response.data.length == 0)
                                            dataBailleur = null;
                                        else {
                                            dataBailleur = response.data;
                                            $scope.titleBailleur =
                                                response.data?.localisation?.bailleur;
                                            $scope.titleResidence = response.config.params.residences ?
                                                JSON.parse(response.config.params.residences).join(',') : '';
                                        }
                                        done();
                                    },
                                    function (err) {
                                        dataBailleur = null;
                                        done();
                                    }
                                );
                            } else {
                                done();
                            }
                        },
                    ],
                    function (err, result) {
                        $timeout(function () {
                            if (dataTerritoire) {
                                $scope.dataTerritoire = new classTerritoire(
                                    dataTerritoire,
                                    dataDepartement,
                                    dataEPCI,
                                    dataCommune
                                );
                            } else {
                                $scope.dataTerritoire = null;
                            }

                            if (dataBailleur) {
                                $scope.dataBailleur = new classBailleur(
                                    dataBailleur,
                                    dataTerritoire
                                );
                                // $scope.dataBailleur = new classTerritoire(dataTerritoire, dataDepartement, dataEPCI, dataCommune);
                            } else {
                                $scope.dataBailleur = null;
                            }
                            $timeout(function () {
                                $rootScope.$broadcast(
                                    "redrawGraph",
                                    "blue",
                                    $scope.dataTerritoire,
                                    $scope.dataBailleur
                                );
                                $rootScope.$broadcast(
                                    "redrawGraph",
                                    "green",
                                    $scope.dataBailleur,
                                    $scope.dataTerritoire
                                );
                                let highestBox = 0;
                                let listDiv: any;
                                listDiv = $(".divSameSize");
                                _.forEach(listDiv, function (div: any) {
                                    if ($(div).height() > highestBox) {
                                        highestBox = $(div).height();
                                    }
                                });
                                _.forEach(listDiv, function (div: any) {
                                    $(div).height(highestBox);
                                });
                            }, 1000);
                        });
                    }
                );
            }

            //EVENTS
            $scope.changeRegion = function () {
                setRegion();
                refreshDOM();
            };
            $scope.changeDepartement = function () {
                setDepartement();
                refreshDOM();
            };
            $scope.changeEpci = function () {
                setEpci();
                refreshDOM();
            };
            $scope.changeCommune = function () {
                setCommune();
                if ($scope.selectedOrganisation) {
                    fetchResidences();
                }
                refreshDOM();
            };
            $scope.changeOrganisation = function () {
                if ($scope.selectedCommune) {
                    fetchResidences();
                }
                refreshDOM();
            };
            $scope.changeResidence = function () {
                refreshDOM();
            }
            $scope.getFicheTerritoire = function () {
                getFicheTerritoire();
            };
            $scope.reset = function () {
                RAZinputs();
                refreshDOM();
            };
            $scope.filter = function () {
                RAZinputs();
                refreshDOM();
            };
            $scope.initialisation();
        });

        /*

        // Load the Visualization API and the corechart package.
        google.charts.load('current', {'packages':['corechart']});

              // Set a callback to run when the Google Visualization API is loaded.
              google.charts.setOnLoadCallback(drawChart);

              // Callback that creates and populates a data table,
              // instantiates the pie chart, passes in the data and
              // draws it.
              function drawChart() {

                // Create the data table.
                let data = new google.visualization.DataTable();
                data.addColumn('string', 'Topping');
                data.addColumn('number', 'Slices');
                data.addRows([
                  ['Mushrooms', 3],
                  ['Onions', 1],
                  ['Olives', 1],
                  ['Zucchini', 1],
                  ['Pepperoni', 2]
                ]);

                // Set chart options
                let options = {'title':'How Much Pizza I Ate Last Night',
                               'width':400,
                               'height':300};

                // Instantiate and draw our chart, passing in some options.
                let chart = new google.visualization.PieChart(document.getElementById('chart_div'));
                chart.draw(data, options);
              }*/
    },
]);

App.filter("percentage", [
    "$filter",
    function ($filter) {
        return function (input, decimals) {
            if (!_.isNil(input))
                return $filter("number")(input * 100, decimals) + "%";
            else return "";
        };
    },
]).filter("euro", [
    "$filter",
    function ($filter) {
        return function (input, decimals) {
            if (input) return $filter("number")(input, decimals) + "€";
            else return "";
        };
    },
]);

let moduleName: string = App.name;
export default moduleName;



// WEBPACK FOOTER //
// ./resources/assets/js/territoires.ts